import { Suspense, lazy } from 'react'
import { useNavigate } from 'react-router-dom'

const HeroBooking = lazy(
    () => import('../../features/HeroSection/ui/HeroBooking/HeroBooking')
)

export const BookPage = () => {
    const navigate = useNavigate()

    return (
        <div style={{ minHeight: '100vh', backgroundColor: 'var(--primary-bg-color)' }}>
            <Suspense fallback={null}>
                <HeroBooking open onClose={() => navigate('/')} />
            </Suspense>
        </div>
    )
}
